import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { HuonekorttiResponse } from '@/api/models/huonekortti-response';
import { HuonekorttiSahkoluokka } from '@/api/models/huonekortti-sahkoluokka';
import ToimintaAika from '@/types/ToimintaAikaEnum';
import { useHuonekorttiMuokkausComponent } from './huonekorttiMuokkaus';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiMuokkausHuonekortti',
  setup(__props) {

const huonekortti = ref<HuonekorttiResponse>({} as HuonekorttiResponse)
const sahkoluokat = Object.values(HuonekorttiSahkoluokka)
const toimintaAika = ToimintaAika
const { overwriteHuonekortit } = useHuonekorttiMuokkausComponent()

const ylikirjoita = () => {
    overwriteHuonekortit(huonekortti.value)
    huonekortti.value = {} as HuonekorttiResponse
}


return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "el-card-blank",
    shadow: "never"
  }, {
    header: _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createTextVNode(" Muokkaa kaikkia alla olevia huonekortteja ", -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Henkilömäärä norm.",
            prop: "henkilomaaraNorm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                min: 0,
                size: "small",
                modelValue: huonekortti.value.henkilomaaraNorm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((huonekortti.value.henkilomaaraNorm) = $event)),
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Henkilömäärä max",
            prop: "henkilomaaraMax"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                min: 0,
                size: "small",
                modelValue: huonekortti.value.henkilomaaraMax,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((huonekortti.value.henkilomaaraMax) = $event)),
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Toiminta-aika",
            prop: "toimintaAika"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                "allow-create": "",
                filterable: "",
                placeholder: "Valitse tai kirjoita",
                size: "small",
                modelValue: huonekortti.value.toimintaAika,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((huonekortti.value.toimintaAika) = $event)),
                style: {"width":"200px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toimintaAika), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Sähköluokka",
            prop: "sahkoluokka"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: huonekortti.value.sahkoluokka,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((huonekortti.value.sahkoluokka) = $event)),
                placeholder: "Valitse sähköluokka",
                size: "small",
                style: {"width":"180px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sahkoluokat), (luokka) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: luokka,
                      label: luokka,
                      value: luokka
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: " " }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                onClick: ylikirjoita,
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Ylikirjoita", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})